import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { sessionActions } from "./store/session";

// Função para capturar host dinâmico
const getCurrentDomain = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "http://localhost:3000";
};

/**
 * RevendaProvider - Carrega dados da revenda (white-label) e armazena no Redux
 *
 * NOTA: Este provider NÃO cria seu próprio ThemeProvider.
 * O tema é gerenciado pelo AppThemeProvider que já lê revenda do Redux.
 * Isso evita conflitos de tema e permite controle centralizado via server.attributes.darkMode.
 */
const RevendaProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRevenda = async () => {
      try {
        const domain = getCurrentDomain();
        const url = `/api/revendas/public?domain=${encodeURIComponent(domain)}`;

        const res = await fetch(url);
        if (!res.ok) throw new Error(`Erro ao carregar revenda (${res.status})`);

        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          dispatch(sessionActions.setRevenda(data[0]));
        } else if (!domain.includes('localhost')) {
          // Only warn in production, not in development (localhost)
          console.warn("Nenhuma revenda encontrada para o domínio:", domain);
        }
      } catch (err) {
        console.error("Erro ao buscar revenda:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRevenda();
  }, [dispatch]);

  if (loading) {
    return null; // ou um spinner se quiser
  }

  // Apenas passa children - tema é gerenciado pelo AppThemeProvider
  return children;
};

export default RevendaProvider;
